window._ = require('lodash');
window.Popper = require('popper.js').default;
window.Pusher = require('pusher-js');
import config from './config';

import axios from 'axios';
import Echo from 'laravel-echo';
import router from './router';
import store from './store';

axios.defaults.baseURL = config.API_URL;
axios.defaults.withCredentials = true;
axios.defaults.headers.post['Accept'] = 'application/json';
axios.defaults.headers.post['Content-Type'] = 'application/json';
axios.defaults.headers.common['X-Requested-With'] = 'XMLHttpRequest';

axios.interceptors.request.use(
  (config) => {
    let langue = store.getters['app/config'].defaultLangue.code;

    /**Correction */
    if (store.getters['app/config'].langues.length > 0) {
      if (store.getters['auth/user']) {
        langue = store.getters['auth/user'].langue_code;
      } else if (store.getters['app/societe']) {
        langue = store.getters['app/societe'].langue.code;
      }
    }

    store.dispatch('app/setLoader', {
      isLoading: true,
      fullPage: true,
      canCancel: false,
    });

    config.headers.common['locale'] = langue;
    return config;
  },
  function (error) {
    store.dispatch('app/setLoader', {
      isLoading: false,
      fullPage: false,
      canCancel: false,
    });
    return Promise.reject(error);
  }
);

axios.interceptors.response.use(
  function (response) {
    store.dispatch('app/setLoader', {
      isLoading: false,
      fullPage: false,
      canCancel: false,
    });
    return response;
  },
  function (error) {
    store.dispatch('app/setLoader', {
      isLoading: false,
      fullPage: false,
      canCancel: false,
    });

    if (error.response.status === 403) {
      router.push({ name: 'page403' });
    }

    return Promise.reject(error);
  }
);

window.axios = axios;
window.Timer = 10500;

/*window.Echo = new Echo({
  broadcaster: 'pusher',
  key: config.PUSHER_APP_KEY,
  cluster: config.PUSHER_APP_CLUSTER,
  encrypted: true,
  authorizer: (channel) => {
    return {
      authorize: (socketId, callback) => {
        window.axios
          .post('api/back/broadcasting/auth', {
            socket_id: socketId,
            channel_name: channel.name,
          })
          .then((response) => {
            callback(false, response.data);
          })
          .catch((error) => {
            callback(true, error);
          });
      },
    };
  },
});*/
